const p1 = "/assets/sampleProjects/p1.webp";
// const p2 = "/assets/sampleProjects/p2.webp";
const p3 = "/assets/sampleProjects/p3.webp";
const p4 = "/assets/sampleProjects/p4.webp";
const p5 = "/assets/sampleProjects/p5.webp";
const p6 = "/assets/sampleProjects/p6.webp";
const p7 = "/assets/sampleProjects/p7.webp";
const p8 = "/assets/sampleProjects/p8.webp";
// const p9 = "/assets/sampleProjects/p9.webp";
const p10 = "/assets/sampleProjects/p10.webp";
const p11 = "/assets/sampleProjects/p11.webp";
const p13 = "/assets/sampleProjects/p13.webp";

export const ProjectsData = [
  {
    image: p1,
    title: "MedCity",
    description:
      "MedCity is a modern healthcare platform that blends advanced technology with compassionate care. It offers easy access to doctors, essential medical services, health tips, and wellness products-all in one place. With flexible health plans and expert specialists, MedCity makes quality healthcare simple and accessible. Built with a mission to support healthier lives, it aims to be the trusted healthcare partner for every home.",
  },
  // {
  //     image: p1,
  //     title: "Kaffen Restaurant",
  //     description:
  //     "Kaffen Coffee House is a warm and modern café website crafted to bring the full coffee-shop experience online. From signature brews and chef-made treats to reservations, reviews, and engaging coffee blogs, the site blends style with functionality. Visitors can explore menus, meet baristas, read stories behind every cup, and seamlessly book their favorite spot. Designed with a cozy aesthetic and user-friendly flow, Kaffen turns every digital visit into a café moment to savor."
  // },
  {
    image: p3,
    title: "Real State",
    description:
      "Chata is a modern property platform designed to help users easily find, explore, and book their ideal flats. It features verified listings, flexible pricing plans, high-quality images, and detailed property insights for informed decision-making. Users can browse premium apartments, view amenities, request visits, or contact agents directly through the site. Built with a clean and user-friendly design, the platform delivers a seamless property-search experience from discovery to booking.",
  },
  {
    image: p4,
    title: "ELEOS Digital Branding",
    description:
      "We craft distinctive digital identities that leave lasting impressions. Our approach blends minimalist aesthetics with strategic thinking to create brands that truly resonate. From web design and branding to photography and beyond, we transform ideas into immersive digital experiences. Each project showcases our commitment to elegant design that connects meaningfully with audiences.",
  },
  {
    image: p5,
    title: "CityScape",
    description:
      "CityScape is a user-friendly real-estate platform for browsing, comparing, and viewing property details. It enhances online presence for real-estate businesses by offering a clean, responsive interface that helps buyers make confident decisions.",
  },
  {
    image: p6,
    title: "Star Belly",
    description:
      "Star Belly provides a smooth online experience to explore menus, read blogs, shop products, and place orders. It strengthens branding and customer engagement while supporting online sales.",
  },
  {
    image: p7,
    title: "OXYBUILD",
    description:
      "OxyBuild showcases the company’s construction expertise, completed projects, and service offerings. It builds trust and credibility by giving clients a clear view of the company’s capabilities and easy contact options.",
  },
  {
    image: p8,
    title: "Charity (Sadakat)",
    description:
      "The Bright Futures Foundation creates life-changing educational opportunities for underprivileged students, ensuring every child can achieve their dreams. Empower through scholarships, tech access, and mentorship, building a community of support and hope. Every contribution helps transform potential into a brighter future. ",
  },
  // {
  //     image: p1,
  //     title: "Photography",
  //     description:
  //     "Captures life’s moments with creativity, authenticity, and emotion. From weddings and portraits to lifestyle and commercial shoots, every frame tells a story. With years of experience and a passion for storytelling, fleeting moments turn into timeless memories. "
  // },
  {
    image: p10,
    title: "Barber Shop",
    description:
      "Combine expertise and care to make look and feel the best. From hair and skin treatments to makeup and nail services, every visit is personalized for confidence and radiance. The skilled team, luxurious space, and premium products ensure a beauty experience that goes beyond the mirror.",
  },
  {
    image: p11,
    title: "Edumim",
    description:
      "Edumim blends classical education with modern online learning, offering expert-led courses in a supportive, student-friendly environment. With high completion rates and engaging content, we help learners achieve their goals anytime, anywhere, while fostering a community built for success. ",
  },
  // {
  //     image: p1,
  //     title: "Phanes",
  //     description:
  //     "Push boundaries to create digital solutions that inspire, engage, and spark curiosity. Driven by original ideas, turn creativity into measurable, innovative work that brings brands to life. With a focus on simplicity, detail, and smart technology, solve business challenges and craft experiences that leave an impact. "
  // },
  {
    image: p13,
    title: "Cybal",
    description:
      "Cybal delivers proactive cybersecurity solutions to keep your business safe, resilient, and compliant. Combine expert guidance, innovative technology, and 24/7 monitoring to protect digital assets from threats. From network and cloud security to risk assessment and incident response, it helps businesses operate confidently in a digital world. ",
  },
  // {
  //     image: p1,
  //     title: "FarmHub",
  //     description:
  //     "Combines innovation and tradition to grow fresh, organic produce while promoting sustainable farming. From eco-friendly cultivation and smart irrigation to community programs and farmer training, we nurture both the land and the people. Creating a greener, healthier future, one crop at a time. "
  // },
];
